import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { Card, CardBody, CardHeader } from 'app/KinerjaShared/components/Card'

type TCardSummaryPraktikKinerjaProps = {
  title: string
  children: React.ReactNode
}
export const CardSummaryPraktikKinerja: React.FC<
  TCardSummaryPraktikKinerjaProps
> = ({ title, children }) => {
  return (
    <div className="flex">
      <Card className="flex flex-col flex-1 border rounded-md border-subdued">
        <CardHeader className="!bg-surface-subdued !p-3">
          <Text variant="heading-sm" className="flex items-center space-x-1">
            <Icon>check_circle_outlined</Icon> <span>{title}</span>
          </Text>
        </CardHeader>

        <CardBody className="flex-1">{children}</CardBody>
      </Card>
    </div>
  )
}
